import { render, staticRenderFns } from "./clinic-switcher.vue?vue&type=template&id=d8225488&scoped=true"
import script from "./clinic-switcher.vue?vue&type=script&lang=js"
export * from "./clinic-switcher.vue?vue&type=script&lang=js"
import style0 from "./clinic-switcher.vue?vue&type=style&index=0&id=d8225488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8225488",
  null
  
)

export default component.exports